var _defs, _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKotlin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 194.03 194",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 144.87,
    y1: -1532.12,
    x2: 47.95,
    y2: -1629.04,
    gradientTransform: "matrix(1, 0, 0, -1, 0.62, -1483.26)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e44857"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#c711e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7f52ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logotypes"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "145.48 145.44 48.55 145.44 48.55 48.56 145.48 48.56 97.01 96.97 145.48 145.44"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path80319",
    className: "cls-2",
    d: "M81.61,116l11.17,6.44a1.3,1.3,0,0,0,1.79-.48,1.28,1.28,0,0,0-.48-1.77l-11.3-6.54a40.78,40.78,0,0,0,0-33.24l11.3-6.54a1.31,1.31,0,0,0-1.31-2.27L81.61,78A38.5,38.5,0,0,0,51.17,58.16v77.68A38.38,38.38,0,0,0,81.61,116ZM62.09,79.17a3.26,3.26,0,1,1,3.25,3.25A3.25,3.25,0,0,1,62.09,79.17Zm0,35.66a3.26,3.26,0,1,1,3.25,3.26A3.25,3.25,0,0,1,62.09,114.83Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKotlin);
export default __webpack_public_path__ + "static/media/kotlin.3343caf1440b92a522ff371ede547511.svg";
export { ForwardRef as ReactComponent };